/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import { PROMETHEAN_SIGN_IN_BG, PROMETHEAN_NEUTRAL_WHITE } from '@prom/web-embers'

export const StyledLayout = styled('div')({
  background: PROMETHEAN_SIGN_IN_BG,
  position: 'relative',
  height: '100%',

  '&.scroll': {
    overflowY: 'auto',
    overflow: 'hidden overlay',
    scrollBehavior: 'smooth',
    '-webkit-overflow-scrolling': 'touch',
  },

  '.Layout': {
    '&-leftFire': {
      position: 'fixed',
      bottom: 0,
      left: '0px /*! @noflip */',
      zIndex: 0,
      opacity: 0.5,
      '@media screen and (max-width: 446px)': {
        opacity: 0,
      },
    },

    '&-rightFire': {
      position: 'fixed',
      top: 0,
      right: '0px /*! @noflip */',
      zIndex: 0,
      opacity: 0.5,
      mixBlendMode: 'overlay',
      '@media screen and (max-width: 446px)': {
        opacity: 0,
      },
    },

    '&-content': {
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      paddingTop: 100,
      '@media screen and (max-width: 446px)': {
        paddingTop: 0,
      },
    },

    '&-formItem': {
      marginBottom: 16,
      '&.last': {
        marginBottom: 0,
      },
    },
  },

  '@media screen and (max-width: 446px)': {
    paddingTop: 0,
    background: `${PROMETHEAN_NEUTRAL_WHITE} !important`,
  },
})
